var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewTown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2225_4508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.97583 20.661C9.17556 20.6608 8.3927 20.4248 7.72295 19.982C7.05321 19.5391 6.52561 18.9085 6.20467 18.1674C5.88373 17.4262 5.78335 16.6065 5.91583 15.8086C6.0483 15.0107 6.40788 14.2691 6.95059 13.6745C6.2182 12.3153 5.83571 10.7918 5.83831 9.24409C5.83831 8.99685 5.83832 8.7496 5.86987 8.50635C4.71343 8.93034 3.65641 9.59195 2.76543 10.4495C1.87445 11.307 1.16883 12.3418 0.693062 13.4887C0.217294 14.6356 -0.0182965 15.8698 0.00110833 17.1133C0.0205131 18.3568 0.294507 19.5828 0.805824 20.714C1.31714 21.8451 2.05467 22.8569 2.97196 23.6856C3.88925 24.5143 4.96641 25.1418 6.1355 25.5287C7.3046 25.9156 8.54028 26.0535 9.76468 25.9336C10.9891 25.8137 12.1756 25.4387 13.2496 24.8321V19.022C12.866 19.5321 12.3709 19.9455 11.8029 20.2298C11.235 20.5142 10.6096 20.6617 9.97583 20.661Z",
    fill: "url(#paint0_linear_2225_4508)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97546 12.3346C10.4276 12.3348 10.8767 12.4103 11.3047 12.5579C10.9723 12.0421 10.7485 11.4625 10.6472 10.8554C10.5459 10.2483 10.5693 9.62668 10.7159 9.02912C10.8626 8.43156 11.1293 7.87091 11.4995 7.38207C11.8697 6.89322 12.3354 6.48664 12.8678 6.18765C13.4001 5.88865 13.9876 5.70363 14.5937 5.6441C15.1998 5.58458 15.8115 5.65181 16.3908 5.84164C16.9701 6.03147 17.5046 6.33982 17.9609 6.7475C18.4172 7.15517 18.7857 7.65344 19.0433 8.2113C20.7444 7.80225 22.5266 7.90482 24.1708 8.50639C24.0582 7.13177 23.6437 5.79988 22.9575 4.60777C22.2712 3.41565 21.3305 2.39336 20.2039 1.61541C19.0774 0.837456 17.7933 0.323428 16.4453 0.11081C15.0973 -0.101807 13.7194 -0.0076579 12.412 0.386379C11.1045 0.780415 9.90055 1.46442 8.88773 2.38854C7.87492 3.31266 7.07882 4.4536 6.55744 5.72822C6.03605 7.00284 5.80252 8.37904 5.87388 9.75647C5.94525 11.1339 6.3197 12.4779 6.96994 13.6904C7.35178 13.2677 7.81577 12.9291 8.3329 12.6958C8.85004 12.4625 9.4092 12.3395 9.97546 12.3346Z",
    fill: "url(#paint1_linear_2225_4508)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1063 7.96802C20.4116 7.96738 19.7193 8.04902 19.0434 8.21127C19.3588 8.90416 19.4943 9.66694 19.437 10.4275C19.3797 11.1881 19.1316 11.9213 18.716 12.5579C19.4335 12.311 20.2044 12.269 20.9439 12.4366C21.6834 12.6043 22.3629 12.975 22.9073 13.508C23.4518 14.041 23.8403 14.7156 24.0299 15.4574C24.2195 16.1993 24.2029 16.9797 23.982 17.7126C23.7611 18.4456 23.3443 19.1027 22.7777 19.6115C22.2111 20.1204 21.5166 20.4613 20.7706 20.5967C20.0247 20.7321 19.2562 20.6567 18.5499 20.3789C17.8436 20.101 17.2269 19.6315 16.7676 19.022V24.8321C17.9557 25.5036 19.2802 25.8907 20.6395 25.9639C21.9987 26.037 23.3564 25.7942 24.6083 25.2541C25.8602 24.714 26.9731 23.891 27.8613 22.8483C28.7496 21.8055 29.3896 20.5708 29.7322 19.239C30.0749 17.9072 30.111 16.5137 29.8379 15.1655C29.5648 13.8173 28.9896 12.5504 28.1567 11.462C27.3237 10.3737 26.2551 9.49279 25.0329 8.88709C23.8107 8.2814 22.4674 7.96699 21.1063 7.96802Z",
    fill: "url(#paint2_linear_2225_4508)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2225_4508",
    x1: 7.96821,
    y1: 26.0643,
    x2: 4.83768,
    y2: 8.50613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#54C3F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#4FBDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#40ADE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#2792D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#046CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2225_4508",
    x1: 14102.5,
    y1: 9949.66,
    x2: 14835.2,
    y2: 9592.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#54C3F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#4FBDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#40ADE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#2792D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#046CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2225_4508",
    x1: 10885.4,
    y1: 13075.7,
    x2: 10700.6,
    y2: 13847.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#54C3F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#4FBDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#40ADE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#2792D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#046CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068B7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2225_4508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 26,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTown);
export default __webpack_public_path__ + "static/media/newTown.e64576824431250d1b0942ecca8ea9e4.svg";
export { ForwardRef as ReactComponent };